export default __webpack_public_path__ + "static/media/group2.eccb736f.jpg";